<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import BaseTooltip from "@/components/ui/BaseTooltip/BaseTooltip.vue";
import IconButton from "@/components/ui/IconButton/IconButton.vue";

const props = defineProps<{
  text: string | (() => string);
}>();

const emit = defineEmits<{
  copied: [];
}>();

const { t } = useI18n();
const copied = ref(false);
let copyResetTimer: ReturnType<typeof setTimeout> | undefined;

async function copy() {
  const value = typeof props.text === "function" ? props.text() : props.text;
  try {
    await navigator.clipboard.writeText(value);
  } catch {
    return;
  }
  emit("copied");
  copied.value = true;
  clearTimeout(copyResetTimer);
  copyResetTimer = setTimeout(() => {
    copied.value = false;
  }, 2000);
}
</script>

<template>
  <BaseTooltip
    :content="copied ? t('general.copied') : t('general.copy')"
    :hide-on-click="false"
    class="copy-button"
  >
    <IconButton
      :icon="copied ? 'system/check' : 'general/duplicate'"
      variant="ghost"
      size="small"
      :aria-label="copied ? t('general.copied') : t('general.copy')"
      @click="copy"
    />
  </BaseTooltip>
</template>
